import styled from "styled-components";

export const LineaContainer = styled.div`
  /* position: fixed; */
  margin-left: 50px;
  margin-top: 170px;
  left: 20%;
  @media (max-width: 1280px) {
    margin-left: 20px;
  }
`;

export const CirculoTarea = styled.hr`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: var(--color-buscarCards-dots-color);
`;
